
import { Button, ContextMenuModal, ContextMenuWrapper, Dropdown, IconButton, MenuItem, MenuList, Modal } from 'bimui';
import './index.less';
import { useContext, useRef, useState } from 'react';
import { EngineContext, RegisterContext } from '@/App';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import ColorPalette from '@/layout/graphic/operation-bar/color-palette-modal';
import { ReactComponent as UndoSvg } from 'bimui/dist/c1/icons/undo_20.svg';
import { ReactComponent as RedoSvg } from 'bimui/dist/c1/icons/redo_20.svg';
import { ReactComponent as EditSvg } from 'bimui/dist/c1/icons/edit_20.svg';
import { ReactComponent as MoveSvg } from 'bimui/dist/c1/icons/move_20.svg';
import { ReactComponent as DeleteSvg } from 'bimui/dist/c1/icons/delete_20.svg';
import { ReactComponent as RotateSvg } from 'bimui/dist/c1/icons/rotate_20.svg';
import { ReactComponent as ScaleSvg } from 'bimui/dist/c1/icons/scale_20.svg';
import { ReactComponent as FilletSvg } from 'bimui/dist/c1/icons/fillet_20.svg';
import { ReactComponent as ChamferSvg } from 'bimui/dist/c1/icons/chamfer_20.svg';
import { ReactComponent as CopySvg } from 'bimui/dist/c1/icons/copy_20.svg';
import { ReactComponent as RArraySvg } from 'bimui/dist/c1/icons/rectangular-array_20.svg';
import { ReactComponent as AlignSvg } from 'bimui/dist/c1/icons/align_20.svg';
import { ReactComponent as UnionSvg } from 'bimui/dist/c1/icons/union_20.svg';
import { ReactComponent as TextSvg } from 'bimui/dist/c1/icons/text-size-setting_20.svg';
import { ReactComponent as TextAnnotationSvg } from 'bimui/dist/c1/icons/text-annotation_20.svg';
import { ReactComponent as TextOrthSvg } from 'bimui/dist/c1/icons/orthogonal-dimensioning_20.svg';
import { ReactComponent as TextAngleSvg } from 'bimui/dist/c1/icons/angle-dimensioning_20.svg';
import { ReactComponent as TextRadiusSvg } from 'bimui/dist/c1/icons/radius-dimensioning_20.svg';
import { ReactComponent as ArrowSvg } from 'bimui/dist/c1/icons/dropdown.svg';
import { ReactComponent as ShowSelectSvg } from 'bimui/dist/c1/icons/selected-display_20.svg';
import { ReactComponent as ShowReverseSvg } from 'bimui/dist/c1/icons/reverse-display_20.svg';
import { ReactComponent as ShowAllSvg } from 'bimui/dist/c1/icons/display-all_20.svg';
import ColorPalettePanel from '@/layout/graphic/operation-bar/color-palette-panel';
import { ReactComponent as UcsSvg } from 'bimui/dist/c1/icons/ucs_20.svg';
import { ReactComponent as LayerSvg } from 'bimui/dist/c1/icons/layer_20.svg';
import { ReactComponent as LineTypeSvg } from 'bimui/dist/c1/icons/line-type_20.svg';
import { ReactComponent as AxisNumber20Svg } from 'bimui/dist/c1/icons/axis-numbering_20.svg';
import { ReactComponent as Orthogonal20Svg } from 'bimui/dist/c1/icons/orthogonal-dimensioning_20.svg';
import { ReactComponent as Slant20Svg } from 'bimui/dist/c1/icons/slant_20.svg';
import { AxesPrimitive } from 'pytha2';
import LayerManage from '@/components/layer/LayerManage';
import UcsManage from '@/components/ucs/UcsManage';

/**
 * 操作工具
 */
export default function SystemLibOperationBar() {

    const { emitCommand, layers, setCurrentLayerUuid, currentLayerUuid, engine, setLayers } = useContext(EngineContext);
    const registerContext = useContext(RegisterContext);
    // 菜单
    const [showTextMenu, setShowTextMenu] = useState<boolean>(false);
    const [showAnnoMenu, setShowAnnoMenu] = useState<boolean>(false);
    const [left, setLeft] = useState(0);
    const [top, setTop] = useState(0);

    const [colorDropVisible, setColorDropVisible] = useState(false);    // 控制颜色下拉菜单的显示与隐藏
    const [displayColor, setDisplayColor] = useState<string>('#ffba84'); // 当前工具栏展示颜色
    const [isMixColor, setIsMixColor] = useState<boolean>(false); // 是否同时有多种颜色 （多个构件选中）
    const [paletteModalVisible, setPaletteModalVisible] = useState(false);   // 控制调色板模态框的显示与隐藏
    const [axesList, setAxesList] = useState<AxesPrimitive[]>([]);   // 坐标系列表
    const axesListRef = useRef<AxesPrimitive[]>([]); // 坐标系列表
    const [selectedUcs, setSelectedUcs] = useState<string>(''); // 当前选中的ucs
    const [selectedLineType, setSelectedLineType] = useState<string>(''); // 当前选中的线型
    const selectedUcsRef = useRef<string>('');
    const [displayLayerUuid, setDisplayLayerUuid] = useState<string>('');
    const [showLayerManage, setShowLayerManage] = useState<boolean>(false); // 显示图层管理
    const [showUcsManage, setShowUcsManage] = useState<boolean>(false); // 显示UCS管理
    const [lineTypes, setLineTypes] = useState<any[]>([]); // 线型列表


    // 修改颜色
    const onColorChange = (color: string) => {
        setColorDropVisible(false);
        setPaletteModalVisible(false);
    }

    // 切换ucs
    const onChangeUSE = (uuid: string) => {
        const axes = axesList.find(a => a.uuid === uuid);
        if (!axes) return;
    };

    // 切换图层
    const handleLayerChange = (value: string) => {

    };

    // 切换线型
    const handleLineTypeChange = (value: string) => {

    }

    return (
        <div className="system-lib-operation">
            <div className='select-container'>
                <IconButton icon={<UcsSvg />} onClick={() => { }}></IconButton>
                <Dropdown
                    options={axesList.map(axes => ({
                        value: axes.uuid,
                        label: axes.name
                    }))}
                    onChange={(value) => onChangeUSE(value)}
                    value={selectedUcs}
                    placeholder='坐标系' />
            </div>
            {/* 图层 */}
            <div className='select-container'>
                <IconButton icon={<LayerSvg />} onClick={() => { }}></IconButton>
                <Dropdown
                    options={layers.map(layer => ({
                        value: layer.uuid,
                        label: layer.name
                    }))}
                    onChange={(value) => handleLineTypeChange(value)}
                    value={displayLayerUuid}
                    placeholder='图层'
                />
            </div>
            {/* 线型 */}
            <div className='select-container'>
                <IconButton icon={<LineTypeSvg />} onClick={() => { }}></IconButton>
                <Dropdown
                    options={lineTypes.map(layer => ({
                        value: layer.uuid,
                        label: layer.name
                    }))}
                    onChange={(value) => handleLayerChange(value)}
                    value={selectedLineType}
                    placeholder='线型'
                />
            </div>
            <ContextMenuWrapper
                width={220}
                visible={colorDropVisible}
                onVisibleChange={(visible) => setColorDropVisible(visible)}
                container={(
                    <Button wrapClassName='color-btn'>
                        <div style={{
                            backgroundColor: `${displayColor}`,
                            width: '20px',
                            height: '20px'
                        }}>
                            {isMixColor && "?"}
                        </div>
                    </Button>
                )}>
                <ColorPalettePanel
                    onColorClick={(color: string) => onColorChange(color)}
                    onModalClick={() => {
                        setColorDropVisible(false);
                        setPaletteModalVisible(true);
                    }} />
            </ContextMenuWrapper>
            <IconButton icon={<UndoSvg />} onClick={() => { emitCommand("UNDO") }}></IconButton>
            <IconButton icon={<RedoSvg />} onClick={() => { emitCommand("REDO") }}></IconButton>
            <div className='tool-bar-divider'></div>
            <IconButton icon={<EditSvg />} onClick={() => {
                if (!registerContext.isSidebarCollapsed) { emitter.emit(Emit_Event_Common_Tool.EDIT); }
            }}></IconButton>
            <IconButton icon={<MoveSvg />} onClick={() => { emitCommand("MOVE") }}></IconButton>
            <IconButton icon={<DeleteSvg />} onClick={() => {
                emitCommand("DELETE");
                if (!registerContext.isSidebarCollapsed) {
                    emitter.emit(Emit_Event_Common_Tool.DELETE);
                }
            }}></IconButton>
            <IconButton icon={<AlignSvg />} onClick={() => { }}></IconButton>
            <IconButton icon={<RotateSvg />} onClick={() => { emitCommand("ROTATE") }}></IconButton>
            <IconButton icon={<ScaleSvg />} onClick={() => { emitCommand("SCALE") }}></IconButton>
            <IconButton icon={<FilletSvg />} onClick={() => { emitCommand("FILLET") }}></IconButton>
            <IconButton icon={<ChamferSvg />} onClick={() => { emitCommand("CHAMFER") }}></IconButton>
            <IconButton icon={<CopySvg />} onClick={() => {
                emitCommand("COPY");
                if (!registerContext.isSidebarCollapsed) {
                    emitter.emit(Emit_Event_Common_Tool.COPY);
                }
            }}></IconButton>
            <IconButton icon={<RArraySvg />} onClick={() => { emitCommand("RECTARRAY") }}></IconButton>
            <div className='tool-bar-divider'></div>
            <IconButton icon={<UnionSvg />} onClick={() => { emitCommand("RECTARRAY") }}></IconButton>
            <div className='tool-bar-divider'></div>
            <div id='operation-bar-text-btn'>
                <IconButton icon={<TextSvg />} onClick={() => {
                    let dom = document.getElementById('operation-bar-text-btn');
                    let rect = dom.getBoundingClientRect();
                    setTop(rect.top + 32);
                    setLeft(rect.left - 5);
                    setShowTextMenu(true);
                }} style={{ width: 40 }}><ArrowSvg /></IconButton>
            </div>
            <div id='operation-bar-anno-btn'>
                <IconButton icon={<TextOrthSvg />} onClick={() => {
                    let dom = document.getElementById('operation-bar-anno-btn');
                    let rect = dom.getBoundingClientRect();
                    setTop(rect.top + 32);
                    setLeft(rect.left - 5);
                    setShowAnnoMenu(true);
                }} style={{ width: 40 }}><ArrowSvg /></IconButton>
            </div>
            <div className='tool-bar-divider'></div>
            <IconButton icon={<ShowSelectSvg />} onClick={() => { emitCommand("SHOW_SELECTED") }} ></IconButton>
            <IconButton icon={<ShowReverseSvg />} onClick={() => { emitCommand("HIDDEN_SELECTED") }}></IconButton>
            <IconButton icon={<ShowAllSvg />} onClick={() => { emitCommand("SHOW_ALL") }}></IconButton>

            <Modal
                title="图层管理"
                open={showLayerManage}
                showFooter={false}
                width={700}
                mask
                onCancel={() => setShowLayerManage(false)}>
                <LayerManage />
            </Modal>
            <Modal
                title="UCS"
                open={showUcsManage}
                showFooter={false}
                width={400}
                mask
                onCancel={() => setShowUcsManage(false)}
            >
                <UcsManage
                    selectedUuid={selectedUcs}
                    setSelectedUuid={setSelectedUcs}
                    ucsList={axesList}
                    setUcsList={setAxesList}
                    onClose={() => setShowUcsManage(false)}
                />
            </Modal>


            <Modal
                title="选择颜色"
                open={paletteModalVisible}
                width={600}
                showFooter={false}
                wrapClassName="color-select-modal"
                onCancel={() => setPaletteModalVisible(false)}
            >
                <div className="color-select-modal-body">
                    <ColorPalette
                        onComplete={(color: string) => onColorChange(color)}
                        onCancel={() => setPaletteModalVisible(false)}></ColorPalette>
                </div>
            </Modal>

            <ContextMenuModal
                visible={showTextMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowTextMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => setShowTextMenu(false)}><IconButton icon={<TextSvg />} onClick={() => { emitCommand("DTEXT") }}></IconButton></MenuItem>
                    <MenuItem onClick={() => setShowTextMenu(false)}><IconButton icon={<TextAnnotationSvg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => setShowTextMenu(false)}><IconButton icon={<AxisNumber20Svg />} onClick={() => { emitCommand("GENGRIDNUMBER") }}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>

            <ContextMenuModal
                visible={showAnnoMenu}
                left={left}
                top={top}
                onCancel={() => {
                    setShowAnnoMenu(false);
                }}
                wrapperClassname='operation-bar-menu'>
                <MenuList>
                    <MenuItem onClick={() => setShowAnnoMenu(false)}><IconButton icon={<Orthogonal20Svg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => setShowAnnoMenu(false)}><IconButton icon={<Slant20Svg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => setShowAnnoMenu(false)}><IconButton icon={<TextAngleSvg />}></IconButton></MenuItem>
                    <MenuItem onClick={() => setShowAnnoMenu(false)}><IconButton icon={<TextRadiusSvg />}></IconButton></MenuItem>
                </MenuList>
            </ContextMenuModal>
        </div>
    )
}